import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorScreen } from './error-screen';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * ErrorBoundary
 * 
 * Catches runtime React errors and displays a user-friendly error screen.
 * Using a Class Component as it is required for error boundaries in React.
 */
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleBackToHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/'; // Simple way to reset app state on fatal error
  };

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          title="Unexpected Error"
          message="Something went wrong while running the game."
          details={this.state.error?.message}
          onBack={this.handleBackToHome}
        />
      );
    }

    return this.props.children;
  }
}

